import React, { useEffect, useState } from 'react';

import type { MultiWidgetStateStore, TranslateFn } from '@typings/plugin-runtime.ts';

import { CompassView } from './compassViewOnlineMobile.tsx';
import DesktopCompass from './DesktopCompass.tsx';

const DEFAULT_BEARING = 0;

type MapCompassWidgetState = {
  bearing: number;
};

type MapCompassProps = {
  isDesktop: boolean;
  handleMapResetButtonClick: () => void;
  widgetState: MultiWidgetStateStore<MapCompassWidgetState>;
  T: TranslateFn;
};

const MapCompass = ({ isDesktop, handleMapResetButtonClick, widgetState, T }: MapCompassProps) => {
  const [bearing, setBearing] = useState(0);

  useEffect(() => {
    setBearing(widgetState.getState().bearing);
    return widgetState.addCallback(state => setBearing(state.bearing));
  }, [widgetState]);

  if (isDesktop) {
    return (
      <DesktopCompass
        onCompassClick={handleMapResetButtonClick}
        bearing={bearing}
        tooltipContent={T('mapCompass:Reset Map Rotation')}
      />
    );
  }

  return (
    <CompassView resetBearingValue={DEFAULT_BEARING} onCompassClick={handleMapResetButtonClick} bearing={bearing} />
  );
};

export default MapCompass;
